// Own
import { useSendMetricDownloadApp } from '../use-send-metrics';

export default function useGoToDownload() {
  const sendMetricDownloadApp = useSendMetricDownloadApp();
  return () => {
    sendMetricDownloadApp();
  };
}
